// Import Packages
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

// Import Pages
import { Checkboxes, FileInput, FileInputMateDrive, TabPanel } from "../../../FlowConfigurationInputs";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { getExtension } from "../../../../helpers/helper";
import CaptureArea from "./CaptureArea";
// Import Material UI
import FormControl from "@material-ui/core/FormControl";
import { Button, MenuItem, Select, Box } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import CancelIcon from '@material-ui/icons/Cancel';

// Import Recoil
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";

// Import Helpers
import { CheckIfFlowUpdated } from '../../../../helpers/helper';

// TabPanel styling
// function TabPanel({ children, value, index }) {
//   return <div>{value === index && <Box>{children}</Box>}</div>;
// }
// TabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.any.isRequired,
//   value: PropTypes.any.isRequired,
// };


const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 2,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '0.5px solid #D5D5D5',
    paddingLeft: 5,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.

  },
}))(InputBase);
/**
 * @Description this page OCR Library's Capture Text From Image Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
function CaptureTextFromImage({
  action,
  variables,
  variableRender,
  setOpenVariable,
  automId
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.OCR.";
  const [localType, setLocalType] = useState("");
  const [upImg, setUpImg] = useState();
  const [value, setValue] = useState(0);
  const [tab, setTab] = useState(0);
  const initialActionsData = useRecoilValue(initialActions);
  const setSaveAvailable = useSetRecoilState(saveAvailable);
  const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

  const [openCaptureArea, setOpenCaptureArea] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileSize, setFileSize] = useState(0);
  const [imgCoordinate, setImgCoordinate] = useState({ coordinates: [] });
  const reader = new FileReader();
  // const options = {
  //   checkboxes: { label: label + "TRIM-TEXT" },
  // };
  const options = {
    fileInput: {
      checkExtension: (ext) => {
        return true;
      },
      fileType:
        ".jpeg, .pdf, .png, .jpg, .svg",
    },
    checkboxes: { label: label + "OVERWRITE" },
  };

  // set initial action fields value
  useEffect(() => {
    if (action.fields.cropType) {
      let cropType = action.fields.cropType === 'gridCrop' ? 1 : 0
      setValue(cropType);
    } else {
      setValue(0);
    }
    if (!action.fields.localType) {
      action.fields.localType = { value: "BASEDONLOCALE" };
      setLocalType('BASEDONLOCALE');
    } else {
      setLocalType(action.fields.localType.value);
    }
    if (!action.fields.sampleImage) {
      action.fields.sampleImage = { value: "" };
    } else {
      setUpImg(action.fields.sampleImage.byteValue);
    }


    // if (!action.fields.imgURL) {
    //   action.fields.imgURL = { value: "" };
    // } else {
    //   setUpImg(action.fields.imgURL.value);
    // }
    if (!action.fields.completedCrop) {
      action.fields.completedCrop = { value: [] };
    } else {
      setImgCoordinate({ coordinates: action.fields.completedCrop.value });
    }
    if (!action.fields.fileName) {
      action.fields.fileName = { value: "" };
    } else {
      setFileName(action.fields.fileName.value);
    }
    if (!action.fields.fileSize) {
      action.fields.fileSize = { value: 0 };
    }
    if (!action.fields.mediaSize) {
      action.fields.mediaSize = { value: { width: 0, height: 0, div: 0 } };
    }
    if (!action.fields.gridCrop) {
      action.fields.gridCrop = { value: [] };
    }
    // if (!action.fields.actualImagePath) {
    //   action.fields.actualImagePath = { type: "TEXT" };
    // }
    if (!action.fields.fileType) {
      action.fields.fileType = { value: "FILE" };
    } else {
      if (action.fields.fileType.value === "FILE") {
        setTab(0);
      } else {
        setTab(1)
      }
    }
  }, [action, variables, variableRender]);

  reader.onload = function (event) {
    let image = new Image();

    image.onload = function () {
      // let canvas = document.createElement("canvas");
      // let context = canvas.getContext("2d");
      action.fields.mediaSize.value.width = image.width;
      action.fields.mediaSize.value.height = image.height;
      // if (image.width > 2000 && image.width < 3000) {
      //   canvas.width = image.width / 2;
      //   canvas.height = image.height / 2;
      //   context.drawImage(
      //     image,
      //     0,
      //     0,
      //     image.width,
      //     image.height,
      //     0,
      //     0,
      //     canvas.width,
      //     canvas.height
      //   );
      //   setUpImg(canvas.toDataURL());
      //   // set img size
      //   action.fields.mediaSize.value.div = 2;
      //   action.fields.mediaSize.value.width = canvas.width;
      //   action.fields.mediaSize.value.height = canvas.height;
      //   action.fields.sampleImage.byteValue = canvas.toDataURL();
      // } else if (image.width > 3000) {
      //   canvas.width = image.width / 4;
      //   canvas.height = image.height / 4;
      //   context.drawImage(
      //     image,
      //     0,
      //     0,
      //     image.width,
      //     image.height,
      //     0,
      //     0,
      //     canvas.width,
      //     canvas.height
      //   );
      //   // set img size
      //   action.fields.mediaSize.value.div = 4;
      //   action.fields.mediaSize.value.width = canvas.width;
      //   action.fields.mediaSize.value.height = canvas.height;
      //   setUpImg(canvas.toDataURL());
      //   action.fields.sampleImage.byteValue = canvas.toDataURL();
      // } else {
      //   action.fields.mediaSize.value.width = image.width;
      //   action.fields.mediaSize.value.height = image.height;
      // }
    };
    image.src = event.target.result;
  };

  //select file input
  function onSelectFile(e) {
    if (e.target.files && e.target.files.length > 0) {
      reader.addEventListener("load", () => {
        setUpImg(reader.result);
        setFileSize(reader.size);
      });
      reader.readAsDataURL(e.target.files[0]);
      const fullName = e.target.files[0].name;
      setFileSize(e.target.files[0].size);
      action.fields.fileName.value = fullName;
      setFileName(fullName);

      const field = initialActionsData[action.id]?.fields.fileName;
      const oldValue = !field ? undefined : field.value;
      CheckIfFlowUpdated('fileName', action, oldValue, fullName, setSaveAvailable, setChangeFields, changedFieldsState);
    }
  }

  //convert base64 to buffer byte array
  useEffect(() => {
    if (upImg) {
      action.fields.sampleImage = {
        byteValue: upImg,
        value: fileName,
        extension: getExtension(fileName),
        type: "FILE",
        fileSize: fileSize ? fileSize : 0,
      };
      // action.fields.imgURL.value = upImg;
      action.fields.fileSize.value = fileSize;
    }
  }, [action.fields, fileName, fileSize, upImg]);

  // set selected local type
  function handleLocalType(event) {
    const field = initialActionsData[action.id]?.fields.localType;
    const oldValue = !field ? undefined : field.value;
    CheckIfFlowUpdated('localType', action, oldValue, event.target.value, setSaveAvailable, setChangeFields, changedFieldsState);

    setLocalType(event.target.value);
    action.fields.localType.value = event.target.value;
  }

  // delete uploading image
  function handleDeleteImage() {
    setFileName("");
    action.fields.completedCrop.value = [];
    action.fields.sampleImage.byteValue = "";
    action.fields.sampleImage.extension = "";
    action.fields.sampleImage.value = "";
    action.fields.fileName.value = "";
    setImgCoordinate({ coordinates: [] })
    const field = initialActionsData[action.id]?.fields.fileName;
    const oldValue = !field ? undefined : field.value;
    CheckIfFlowUpdated('fileName', action, oldValue, "", setSaveAvailable, setChangeFields, changedFieldsState);
  }

  function handleChangeTabs(newValue) {
    if (newValue === 1) {
      action.fields.actualImagePath.type = 'TEXT';
      action.fields.fileType.value = 'TEXT';
      action.fields.actualImagePath.backup = { value: action.fields.actualImagePath.value };
      action.fields.actualImagePath.value = "";
      if (action.fields.actualImagePath.backupText?.value) {
        action.fields.actualImagePath.value = action.fields.actualImagePath.backupText.value;
      }
    } else {
      // action.fields.actualImagePath.type = 'FILE';
      action.fields.fileType.value = 'FILE';

      action.fields.actualImagePath.backupText = { value: action.fields.actualImagePath.value }
      delete action.fields.actualImagePath.value
      if (action.fields.actualImagePath.backup?.value) {
        action.fields.actualImagePath.value = action.fields.actualImagePath.backup.value;
      }
    }
    const field = initialActionsData[action.id]?.fields.fileType;
    const oldValue = !field ? undefined : field.value;
    let v = newValue === 1 ? 'TEXT' : 'FILE';
    CheckIfFlowUpdated("fileType", action, oldValue, v, setSaveAvailable, setChangeFields, changedFieldsState);
    setTab(newValue);
  }

  // function handleChange(v) {
  //   setValue(v);
  //   action.fields.cropType = v === 1 ? 'gridCrop' : 'completedCrop'
  //   if (v === 0) {
  //     setImgCoordinate({ coordinates: action.fields.completedCrop.value });
  //   } else {
  //     setImgCoordinate({ coordinates: action.fields.gridCrop.value });
  //   }
  // }
  return (
    <div>
      <div className="conf-field-container">

        <FieldLabel name={t(label + "SAMPLE-IMAGE")} is_required />

        {/* {fileName?.length > 0 &&
            <div className="conf-field-container-horizontal">
              <p>{fileName}</p>
              <HighlightOffIcon onClick={handleDeleteImage} style={{ paddingLeft: 5 }} />
            </div>} */}




        {/* <div className="custom-file config-form">
            <input type="file" className="custom-file-input" accept="image/*" id="license-customFile" onChange={onSelectFile} />
            <label className="custom-file-label content-overflow" htmlFor="license-customFile">{t('CONTENT.SETTINGS.GENERAL.CHOOSE')}</label>
          </div> */}



        <div>
          <div className="custom-file config-form" style={{ marginTop: 10, width: '100%' }}>
            <input type="file" className="custom-file-input" accept="image/*" id="license-customFile-sample" onChange={onSelectFile} />
            <label className="custom-file-label content-overflow" style={{ maxWidth: '100%' }} htmlFor="license-customFile-sample">{fileName ? fileName : t('CONTENT.SETTINGS.GENERAL.CHOOSE')}</label>
            {fileName &&
              <CancelIcon onClick={handleDeleteImage} style={{ float: 'right', cursor: 'pointer' }} />}
          </div>
          {/* {(clear && inputValue) &&
                    <CancelIcon onClick={handleClear} style={{ float: 'right', cursor: 'pointer' }} />} */}
        </div>

        {/* <FileInput action={action} inputName="sampleImage" options={options.fileInput} isRequired
          isSize={true} clear={true} hideRequired /> */}
      </div>

      {/* <div className="conf-field-container">
        <div className="condition-tabs">
          <button
            className={`f-s-11 ${value === 0 ? 'condition-active' : ''}`}
            onClick={() => handleChange(0)}>
            {t(label + "CROP")}
          </button>
          <button
            className={`f-s-11 ${value === 1 ? 'condition-active' : ''}`}
            onClick={() => handleChange(1)}>
            {t(label + "GRID-CROP")}
          </button>
        </div>
      </div> */}
      <div className="conf-field-container">
        <Button
          disabled={fileName?.length === 0}
          variant="outlined"
          onClick={() => setOpenCaptureArea(true)}
          style={{
            background: "#031226",
            boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
            borderRadius: 4,
            color: "#fff",
            fontWeight: 700,
            fontSize: '12px',
            opacity: `${fileName.length === 0 ? "0.5" : "1"}`
          }}
        >
          {t(label + "CAPTURE-AREA")}
        </Button>
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + 'ACTUAL-IMAGE-PATH')} is_required />
        <div className="condition-tabs" style={{ marginBottom: 5 }}>
          <button
            className={`f-s-11 ${tab === 0 ? 'condition-active' : ''}`}
            onClick={() => handleChangeTabs(0)}>
            {t(label + 'SELECT-FILE')}
          </button>
          <button
            className={`f-s-11 ${tab === 1 ? 'condition-active' : ''}`}
            onClick={() => handleChangeTabs(1)}>
            {t(label + 'CUSTOM-STRING')}
          </button>
        </div>
        <TabPanel value={tab} index={0}>
          <FileInputMateDrive
            action={action}
            inputName="actualImagePath"
            options={options.fileInput}
            isRequired={true}
            isSize={true}
            hideRequired
            clear={true}
            autom_id={automId}
            disabled={fileName?.length === 0}
          />
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <TextInput action={action} inputName="actualImagePath" isRequired={false} setOpenVariable={setOpenVariable}
            variables={variables} autom_id={automId} mateDrivePath="filePath" disabled={fileName?.length === 0} hideRequired />
        </TabPanel>
        {/* <TextInput disabled={fileName?.length === 0} action={action} inputName="actualImagePath" isRequired={true} setOpenVariable={setOpenVariable}
          variables={variables} hideRequired /> */}
      </div>
      {/* <TabPanel value={value} index={1}>
        <div className="conf-field-container">
          <FieldLabel name={t(label + "ASSIGN-CROP-VALUE")} />
          <VariablePicker
            action={action}
            inputName="gridVariable"
            variables={variables}
            setOpenVariable={setOpenVariable}
            variableRender={variableRender}
            filter="data table"
            isRequired={false}
          />
          <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
        </div>
      </TabPanel> */}
      {/* <div className="conf-field-container">
        <FieldLabel name={t(label + "PATH")} />
        <TextInput
          action={action}
          inputName="imagePath"
          variables={variables}
          setOpenVariable={setOpenVariable}
          defaultValue=""
          isRequired={false}
        />
      </div> */}
      {/* <div className="conf-field-container">
        <Checkboxes
          action={action}
          options={options.checkboxes}
          inputName="isTrim"
          isRequired={false}
        />
      </div> */}
      <div className="conf-field-container">

        <FieldLabel name={t(label + "SELECT-LOCALE")} />
        <FormControl variant="outlined" fullWidth style={{ width: "90%" }}>
          <Select value={localType} onChange={handleLocalType} input={(localType) ? null : <BootstrapInput />}>
            <MenuItem value="BASEDONLOCALE">
              {t(label + "BASED-ON-LOCALE")}
            </MenuItem>
            <MenuItem value="ENGLISH">{t(label + "ENGLISH")}</MenuItem>
          </Select>
        </FormControl>
      </div>
      {/* <div className="conf-field-container">

        <FieldLabel name={t(label + "ASSIGN-VALUE")} is_required />
        <VariablePicker
          action={action}
          inputName="set"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          filter="string"
          isRequired={true}
          hideRequired
        />
        <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
      </div> */}
      {
        openCaptureArea && (
          <CaptureArea
            imgCoordinate={imgCoordinate}
            setImgCoordinate={setImgCoordinate}
            action={action}
            upImg={upImg}
            setOpenCaptureArea={setOpenCaptureArea}
            setOpenVariable={setOpenVariable}
            variables={variables}
            isGrid={value}
          />
        )
      }
    </div >
  );
}

export default CaptureTextFromImage;
